// ═══════════════════════════════════════════════════════════════════════════
// AUREUS SOCIAL PRO — CE QUE SENTRY A LE DROIT DE COLLECTER (RGPD) — une seule écriture.
//
// 🔴 POURQUOI CE FICHIER EXISTE (07/10/2026, montée de @sentry/nextjs 10.75 → 11.0.0).
// En version 10, `sendDefaultPii: false` suffisait : tout ce qui est personnel (utilisateur, cookies, corps de
// requêtes, données de base de données) n'était PAS collecté. La version 11 REMPLACE cette option par
// `dataCollection`, et — c'est un changement de comportement, pas un renommage — **ce qu'on ne précise pas est
// collecté par défaut** : utilisateur et adresse IP, cookies, tous les en-têtes, tous les corps de requêtes et de
// réponses, paramètres liés des requêtes SQL (guide officiel de migration v10 → v11, lu le 07/10/2026). Or l'app
// manipule des NISS, des IBAN, des fiches de paie. Une montée de version « qui ne casse rien » aurait ouvert la
// collecte sans qu'aucune erreur ne le dise.
//
// Chaque catégorie est donc fermée EXPLICITEMENT, ici, une seule fois (R14 bis) : les trois runtimes (navigateur,
// serveur Node, edge) importent cet objet. Le scrubbing de `sentry-scrub.js` reste la seconde ligne de défense.
//
// ⚠️ Plus strict que la v10 sur UN point, voulu : les en-têtes HTTP ne sont plus collectés du tout (la v10 les
// envoyait « filtrés »). Si un jour un en-tête précis manque pour diagnostiquer, l'autoriser par `allow` ici, jamais
// en rouvrant la catégorie entière.
// ═══════════════════════════════════════════════════════════════════════════

export const DATA_COLLECTION_RGPD = Object.freeze({
  // Pas d'utilisateur ni d'adresse IP déduits de la requête. (`Sentry.setUser` posé volontairement reste possible.)
  userInfo: false,
  // Aucun cookie : ils portent la session.
  cookies: false,
  // Aucun en-tête, ni de requête ni de réponse (Authorization, Cookie, x-forwarded-for…).
  httpHeaders: false,
  // Aucun corps de requête ni de réponse : un formulaire employé contient un NISS et un IBAN.
  httpBodies: [],
  // Parité avec la v10 (collectés) : l'URL et la query-string passent par `scrubSentryEvent`.
  urlQueryParams: true,
  // Pas d'intégration GraphQL ni IA dans l'app ; fermés quand même, au cas où une dépendance en ajouterait une.
  graphQL: Object.freeze({ document: false, variables: false }),
  genAI: Object.freeze({ inputs: false, outputs: false }),
  // Paramètres liés et résultats des requêtes SQL (Supabase) : des données de paie.
  databaseQueryData: false,
  // Arguments des tâches de file d'attente.
  queues: false,
  // Aucune variable locale dans les piles d'appel. Le défaut v11 est `true`, mais l'intégration qui les lit reste
  // éteinte tant que `includeLocalVariables` n'est pas posé (il ne l'est nulle part dans l'app, mesuré le 07/10/2026).
  // On ferme quand même : le jour où quelqu'un l'allume « pour diagnostiquer », une variable `niss` ou `iban` ne
  // doit pas partir. `scrubSentryEvent` nettoie `frame.vars` en seconde ligne.
  stackFrameVariables: false,
});
